import React from 'react'

type SleepIconProps = {
  width: number
  height: number
  color: string
  translateX: number
  translateY: number
  viewBoxHeight: number
  viewBoxWidth: number
}

const SleepIcon = ({
  width = 20,
  height = 32,
  color = '#687B8E',
  translateX = -2,
  translateY = -3,
  viewBoxHeight = 32,
  viewBoxWidth = 20
}: SleepIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
  >
    <g
      fill="none"
      fillRule="evenodd"
      transform={`translate(${translateX} ${translateY})`}
    >
      <path d="M0 0L24 0 24 24 0 24z" />
      <path
        fill={color}
        fillRule="nonzero"
        d="M2 15L5.63 15 2 19.2 2 21 8 21 8 19 4.37 19 8 14.8 8 13 2 13z"
      />{' '}
      <path
        fill={color}
        fillRule="nonzero"
        d="M9 10L12.63 10 9 14.2 9 16 15 16 15 14 11.37 14 15 9.8 15 8 9 8z"
      />{' '}
      <path
        fill={color}
        fillRule="nonzero"
        d="M16 5L19.63 5 16 9.2 16 11 22 11 22 9 18.37 9 22 4.8 22 3 16 3z"
      />{' '}
    </g>
  </svg>
)

export default SleepIcon
